define.alias("shared/components/shared/wizard/previous-button", "media/components/shared/wizard/previous-button");